import _ from "lodash";

export const findById = (state, slideId) => {
    return _.find(state.slides, ['id', slideId]);
};

export const filterByStoryId = (state, storyId) => {
    return _.filter(state.slides, ['story_id', storyId])
};
